import movieBorder from '@assets/img/vector/borders/video-border.svg';
export default movieBorder;
